// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import {
  Box,
  Button,
  DismissIcon,
  Flex,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';

import { PROMPTS, usePrompt } from '@jane/shared-ecomm/hooks';
import { useGetStore } from '@jane/shared/data-access';
import type { Store } from '@jane/shared/types';

import type { RootLoaderType } from '../../../data-access';
import {
  useShouldKioskShowGold,
  useTypedRouteLoaderData,
} from '../../../hooks';
import { trackSignInTap } from '../../../util';

const NoWrapButton = styled(Button)({
  whiteSpace: 'nowrap',
});

// 30 minutes
const DISMISS_TIME = 30 * 60 * 1000;

export const SignInPrompt = ({ onClick }: { onClick: () => void }) => {
  const { store: initialStore, storeId } =
    useTypedRouteLoaderData<RootLoaderType>('root');
  const { data: store } = useGetStore<Store>(storeId, {
    initialData: initialStore,
  });

  const shouldShowGold = useShouldKioskShowGold({});
  const authIsEnabled =
    store?.kiosk_allow_auth && store?.kiosk_anonymous_checkout !== 'required';

  const isMobile = useMobileMediaQuery({});
  const [showPrompt, dismissPrompt] = usePrompt({
    prompt: PROMPTS.kioskSignIn,
    dismissible: false, // sets the timer
    dismissTime: DISMISS_TIME,
    showTime: 12, // timer is set to 12 seconds
  });

  const goldText =
    'Sign in to earn cash back and:discover products just for you';
  const nonGoldText = 'Sign in to see personalized:recommendations for you';
  const text = shouldShowGold ? goldText : nonGoldText;

  const handleLoginClick = () => {
    trackSignInTap({
      store,
      source: ['Header'],
    });
    onClick();
  };

  if (!authIsEnabled) return null;

  return showPrompt ? (
    <Box
      background="grays-white"
      position="absolute"
      top={16}
      p={24}
      borderRadius="lg"
    >
      <Flex
        flexDirection="row"
        gap={16}
        width="100%"
        justifyContent="center"
        alignItems="center"
      >
        <div>
          <DismissIcon
            size="lg"
            onClick={dismissPrompt}
            altText="dismiss sign in prompt"
          />
        </div>
        {!isMobile && (
          <Box>
            <Typography whiteSpace="nowrap" variant="mini">
              {text.split(':')[0]}
            </Typography>
            <Typography whiteSpace="nowrap" variant="mini">
              {text.split(':')[1]}
            </Typography>
          </Box>
        )}

        <NoWrapButton label="Sign in" onClick={handleLoginClick} />
      </Flex>
    </Box>
  ) : null;
};
